// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"006cf0b3","37":"926bc7ee","85":"1bdff608","306":"a6f40075"}[chunkId] + ".chunk.css";
};